export enum ExternalAttendeeStaleTimeEnum {
  GetExternalAttendeesSearch = 60000,
}
